import React from 'react';
import './AboutUsSection.css';

function AboutUsSection() {
  return (
    <section className="about-us-section">
      <div className="about-us-container">
        <h2 className="section-title">About Us</h2>
        <p className="section-content">
          Due Mosaic Architects is a high-end architecture studio delivering innovative design solutions for both small and large-scale projects. We specialize in contemporary architecture, high-quality renovations, and refined interior design.
        </p>
        <h2 className="section-title">VISION</h2>
        <p className="section-content">
          Architectural experiences are fundamentally sensory and concurrent. As architects, we engage in the art of shaping space by elucidating the intricate relationship between present and future moments, drawing lessons from history to inform our vision for the future. Our design language evolves through the interplay of continuity and innovation in disciplinary knowledge, allowing us to adapt seamlessly to diverse contexts within the dynamic interplay of SPACE-TIME.
        </p>
      </div>
    </section>
  );
}

export default AboutUsSection;

